import axios, { AxiosResponse } from 'axios'
import { h, Component } from 'preact'
import { t } from '../../libs/translationsUtils/translations'

import Editor from './index.js'
import redirect from '../../utils/redirect'
import Phrase from "../../libs/translationsUtils/phrase";

type topicTypes = 'productUpdates' | 'ideas'

type PostRequestResponse = AxiosResponse<{
  errors: string[],
  success: string | undefined
}>
type PostRequest = (content: string, attachments: {}[], hasFileInProgress: boolean) => Promise<PostRequestResponse>

function newPost (topicId:number, type: topicTypes): PostRequest {
  return (content, attachments, hasFileInProgress) => {
    checkAttachments(hasFileInProgress)
    return axios.post(`/community/api/${type}/${topicId}/reply`, {
      content,
      highlight: false
    })
  }
}

function editPost (topicId: number, replyId: number, type: topicTypes): PostRequest {
  return (content, attachments, hasFileInProgress) => {
    checkAttachments(hasFileInProgress)
    return axios.post(`/community/api/${type}/replies/${replyId}/editContent`, {
      content
    })
  }
}

function determineRequest ({ replyId, isControl, topicId, type }: {replyId: number | null, isControl: boolean, topicId: number, type: topicTypes}) {
  if (replyId !== null) return editPost(topicId, replyId, type)
  return newPost(topicId, type)
}

function checkAttachments (hasFileInProgress: boolean) {
  if (hasFileInProgress) {
    const error = {
      response: {
        data: {
          errors: {
            pagetext: t('Common', 'file.upload.in.progress')
          }
        }
      }
    }
    throw error
  }
}

interface Props {
  replyId: number | null,
  topicId: number,
  isControl: boolean,
  redirect: boolean,
  autoFocus?: boolean,
  isGuest?: boolean,
  onSuccess: (content: string, response: PostRequestResponse) => void,
  onCancel?: () => void,
  disableFileAttachments: boolean,
  data?: string,
  type: topicTypes
}

interface State {
  attachments: {}[],
  errors: {errorMessage: string}[],
  isLoading: boolean
}

export default class extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      attachments: [],
      errors: [],
      isLoading: false
    }
  }

  render (props: Props) {
    const submitRequest = determineRequest(props)
    return <div>
      <Editor
        {...props}
        disableFileAttachments={props.disableFileAttachments}
        isControl={props.isControl}
        autoFocus={!!props.autoFocus}
        errors={this.state.errors}
        isLoading={this.state.isLoading}
        attachments={this.state.attachments}
        onSubmit={async (content: string, attachments: {}[], hasFileInProgress: boolean) => {
          this.setState({
            isLoading: true
          })
          try {
            const response = await submitRequest(content, attachments.map(item => JSON.stringify(item)), hasFileInProgress)
            const errors = response.data.errors
            if (errors && errors.length) {
              const newErrors = errors.map(error => {
                return { errorMessage: error }
              })
              this.setState({
                errors: this.state.errors.concat(newErrors),
                isLoading: false
              })
              return
            }
            if (props.redirect) {
              // This part needs to be updated when we have redirect to post
              return redirect(response.data.success || response.headers.location)
            }
            props.onSuccess(content, response)
            this.setState({ errors: [] })
            window.CKEDITOR.instances['editor1'].setData('')
          } catch (error) {
            let errorMessage

            if (error.response && error.response.status === 422 && error.response.data && error.response.data.description === 'Reply will be moderated by a moderator.') {
              errorMessage = <Phrase m='Forum' p='spam_moderation.reviewbymoderator.message' />
            } else {
              errorMessage = error.response.data?.errors?.pagetext || error.response.data?.errors?.content || error.response.data?.errors || 'Something\'s gone wrong'
            }

            this.setState({
              errors: this.state.errors.concat({
                errorMessage
              })
            })
          }
          this.setState({
            isLoading: false
          })
        }
        } />
    </div>
  }
}
